import React from "react";

import Slider from "react-slick";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import heroImage from "../../assets/all-images/HR2.jpeg";

import "../../styles/hero-slider.css";

const HeroSlider = () => {
  const settings = {
    fade: true,
    speed: 2000,
    autoplaySpeed: 3000,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
  };
  return (
    
    <section className="hero-section flex">
    
        
      <div className="about-content">
      <h6>Welcome to VIYU GROUP</h6>
      <h1>
        <span className="highlight">HR</span> Solutions For A Better Tomorrow
      </h1>
      <p>
        Creating Workplaces Where People Thrives, 
        Let’s Build a Brighter future together.
      </p>
      <button className="hero-button">Request a demo</button>
        
      </div>
      <div className="about-image">
      <img src={heroImage} alt="HR Solutions" />
      </div>
      
    </section>
  );
};

export default HeroSlider;
